import axios from '../../axios'

/*
 * 征集院校数据接口
 */

// 获取征集志愿院校列表
export const getSchoolList = (data) => {
    return axios({
        url: '/api/data/wish/voluntary/supplement/page',
        method: 'get',
        data
    })
}
// 征集志愿id查询
export const getSchoolId = (data) => {
    return axios({
        url: '/api/data/wish/voluntary/supplement/get',
        method: 'get',
        data
    })
}

// 征集志愿新增
export const addSchool = (data) => {
    return axios({
        url: '/api/data/wish/voluntary/supplement',
        method: 'post',
        data
    })
}

// 征集志愿更新
export const updateSchool = (data) => {
    return axios({
        url: '/api/data/wish/voluntary/supplement',
        method: 'put',
        data
    })
}

// 征集志愿删除
export const deleteSchool = (data) => {
    return axios({
        url: '/api/data/wish/voluntary/supplement',
        method: 'delete',
        data
    })
}

// 征集志愿导入
export const importSchool = (data) => {
    return axios({
        url: '/api/data/wish/voluntary/supplement/import',
        method: 'post',
        data
    })
}

// 征集志愿导出
export const exportSchool = (data) => {
    return axios({
        url: '/api/data/wish/voluntary/supplement/export',
        method: 'post',
        data
    })
}

// 征集志愿导入更新
export const importUpdateSchool = (data) => {
    return axios({
        url: '/api/data/wish/voluntary/supplement/import/update',
        method: 'post',
        data
    })
}

// 征集志愿导入删除
export const importDeleteSchool = (data) => {
    return axios({
        url: '/api/data/wish/voluntary/supplement/import/delete',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/info/collectionschool.js